import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { applyCategoryConfig } from './ApplyCategory.name';

/** 申請種類のENUM */
enum ApplyCategory {
  /** 契約台帳 */
  laContractLedger = 'LA_CONTRACT_LEDGER',
  /** 物件台帳 */
  laArticleLedger = 'LA_ARTICLE_LEDGER',
}

const applyCategoryMap = new Map([
  ['LA_CONTRACT_LEDGER', ApplyCategory.laContractLedger],
  ['LA_ARTICLE_LEDGER', ApplyCategory.laArticleLedger],
]);

const rawValueToApplyCategory = rawValueToEnumWithDefault(applyCategoryMap, ApplyCategory.laContractLedger);

const applyCategoryToDisplay = enumToNameWithDefault(ApplyCategory, applyCategoryConfig);

export { ApplyCategory, applyCategoryToDisplay, rawValueToApplyCategory };
